<template>
  <div
  :class="{
			'standard-search': true,
			[size]: true,
			[variant]: true,
			'advanced-search-isScrolled': isScrolled && jobsStandardSearch && !cdljnJobsStandardSearch,
			'job-standard-search': jobsStandardSearch,
      'only-location-input': !showKeywordInput,
      'company-jobs-standard-search': companyJobsStandardSearch
		}"
    class="block md:flex md:justify-between"
  >
    <div class="input-wrapper md:flex md:flex-grow" v-click-outside="hideInputOnMobile">
      <div v-if="showKeywordInput" class="keywords">
        <i class="feather icon-search icon" />
        <form autocomplete="off" @submit.prevent="getJobs">
          <autocomplete
            id="keyword"
            :minLength="1"
            :prepopulateChosen="keywordInput"
            :placeholder="jobPlaceholder"
            @onSelect="onKeywordsSelect"
            @onInput="onKeywordsSelect"
            :apiCall="keywordsApiCall"
            :withPublishedJobs="withPublishedJobs"
            :suggestOnlyCompany="suggestOnlyCompany"
            @onFocusVueSuggest="showAltInputOnMobile(true)"
          />
        </form>
        <primary-button aria-label="Search" :size="size" class="alt-btn" icon="search" @click="getJobsInMobile" />
      </div>
      <div
        class="location"
        :class="{
          'relative': hasLocationErrorOnInput,
          'full_w_input only-location' : !showKeywordInput,
        }"
        ref="location"
      >
        <span v-if="companyJobsStandardSearch"><i class="feather icon-map-pin icon text-lg text-primary-darker" /></span>

        <span v-else><i class="feather icon-map-pin icon" :class="{'ml-0': showOnlyLocationSearch}" /></span>

        <form class="w-full" autocomplete="off" @submit.prevent="getJobs">
          <autocomplete
            id="location"
            :minLength="1"
            use-postal-code
            :prepopulateChosen="prepopulateCity"
            :placeholder="cityPlaceholder"
            @onSelect="onSelect"
            @onInput="onSelect"
            :apiCall="locationApiCall"
          />
        </form>
        <template v-if="hasLocationErrorOnInput">
          <div
            v-if="!companyJobsStandardSearch"
                  class="absolute"
                  style="border: 1px solid rgb(var(--colors-red-500)); border-radius: 12px; left: 15px; top: 15px; right: 15px; bottom: 15px; pointer-events: none; z-index: 0;"
          ></div>
          <div class="absolute std-err-zip-code" style="color: rgb(var(--colors-red-500)); pointer-events: none; z-index: 999; bottom: 0; left: 20px;">Please enter a valid zip code</div>
        </template>
        <primary-button
          v-if="showOnlyLocationSearch || companyJobsStandardSearch"
          :size="size" class="alt-btn ml-auto"
          :class="{'md:hidden' : showOnlyLocationSearch, 'mr-2px': companyJobsStandardSearch}"
          icon="search"
          aria-label="Search"
          @click="getJobs"
        />
      </div>
    </div>
    <div class="button-container" v-if="!companyJobsStandardSearch">
      <div @click="getJobs" title="Search">
        <primary-button aria-label="Search" v-if="!showKeywordInput && cdljnJobsStandardSearch" :size="size" class="alt-btn" icon="search"/>
        <primary-button aria-label="Search" v-else :size="size">Search</primary-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from './Button'
import Autocomplete from './Autocomplete'
import CCRequestInputMixin from "../mixins/CCRequestInputMixin";
import QueryParameters from "../utilities/queryparameters";
import HandleSearchScrollMixin from "../mixins/HandleSearchScrollMixin";
import event from "../event";
import queryBuilder from "../utilities/querybuilder";

export default {
  name: "standard-search",
  mixins: [CCRequestInputMixin, HandleSearchScrollMixin],
  props: {
    hasLocationError: {
      type: Boolean,
      default: false,
    },
    keywordsApiCall: {
        type: String,
        default: ''
    },
    locationApiCall: {
        type: String,
        default: ''
    },
    prepopulateCity: {
        type: String,
        default: ''
    },
    prepopulateKeyword: {
        type: String,
        default: ''
    },
    size: {
      type: String,
      default: "default"
    },
    jobPlaceholder: {
      type: String,
      default: "Job title, keywords or company"
    },
    cityPlaceholder: {
      type: String,
      default: "Search your city, state or ZIP"
    },
    variant: {
      type: String,
      default: ""
    },
    searchUrl: {
        type: String,
        required: true
    },
    withPublishedJobs: {
      type: Boolean,
      default: true
    },
    suggestOnlyCompany: {
      type: Boolean,
      default: false
    },
    jobsStandardSearch: {
      type: Boolean,
      default: false
    },
    cdljnJobsStandardSearch: {
      type: Boolean,
      default: false
    },
    appName: {
      type: String,
      default: ''
    },
    userFilterOptions: {
      type : Object,
      default : () => { return {}}
    },
    showKeywordInput: {
      type: Boolean,
      default: true
    },
    page: {
      type: String,
      default: "default"
    },
    companyJobsStandardSearch: {
      type: Boolean,
      default: false
    },
    showLocationBtn: {
      type: Boolean,
      default: false
    }
  },
    data : function () {
        return {
            keyword : this.prepopulateKeyword,
            location : '',
            hasLocationErrorOnInput: false,
            locationInputDisplayed: true,
        }
    },

    computed : {
        keywordInput : {
            get(){
                if( ! this.locationInputDisplayed ) {
                    if(this.keyword && this.location) {
                        return this.keyword + ' in '+ this.location;
                    }
                    if(this.location){
                        return this.location;
                    }
                }

                if(this.userFilterOptions.search_text) {
                  return this.userFilterOptions.search_text;
                }

                return this.keyword;
            },
            set( keyword) {
                this.keyword = keyword;
            }
      },
      showOnlyLocationSearch() {
        // Show the location search button when keyword is hidden
        return !this.companyJobsStandardSearch && this.showLocationBtn && window.innerWidth < 768
      }
    },

  methods: {

    isMobileVariant() {
        return (window.innerWidth < 768 && this.variant === "alt");
    },

    showAltInputOnMobile(value) {
      if (this.isMobileVariant()) {
        this.locationInputDisplayed = value;
        this.$refs.location.style.display = value === true ? "flex" : "none";
      } else {
        this.$refs.location.style.display = "flex";
      }
    },

    hideInputOnMobile() {
      this.showAltInputOnMobile(false);
    },
    onKeywordsSelect(val) {
        this.keywordInput = val;
    },
    onSelect(val) {
        if ((this.location.toString().length >= 1) && !(/^\d*$/.test(this.location.toString()))) {
          this.hasLocationErrorOnInput = false;
        }

        this.location = val;
    },

    getJobsInMobile() {
        if (this.isMobileVariant()) this.getJobs();
    },

    getJobs() {
      const parameters = `ss=1&${QueryParameters.KEYWORD}=${encodeURIComponent(this.keyword)}&${QueryParameters.PRIMARY_LOCATION}=${encodeURIComponent(this.location).replace(/'/g, " ")}`;
      let page = location.pathname.replace(/^\/+|\/+$/g, '');
      if (page === 'companies') {
        event.bus.$emit('selected-company-filter', this.routeParsed(this.searchUrl, parameters));
      } else {
        window.location = this.routeParsed(this.searchUrl, parameters);
      }
    },
  },

  mounted() {
      this.hasLocationErrorOnInput = this.hasLocationError;
      this.$nextTick(() => {
          this.hideInputOnMobile();
      })

    let vm = this;

    event.bus.$on('ajax-search-error', function (status) {
      vm.hasLocationErrorOnInput = status;
    });
  },

  components: {
    PrimaryButton,
    Autocomplete,
  }
};
</script>

<style lang="scss" scoped>

.job-standard-search {
  max-width: 100% !important;

  @screen md {
    & .keywords {
      flex-basis: auto !important;
      width: 484px !important;
    }
    & .location {
      flex-basis: auto !important;
      width: 375px !important;
      border-right: 1px solid rgb(var(--colors-gray-200)) !important;
    }

    & .location.full_w_input {
      border: 0 !important;
    }
  }

  & .vue-simple-suggest {
    &.designed {
      & .suggestions {
        top: 66px;
        left: 494px;
      }
    }
  }
}

.job-standard-search {
  & .location.full_w_input {
    & .icon {
      margin: 0 10px 0 0 !important;
    }
  }
}

.standard-search {
  width: 100%;
  max-width: 960px;
  box-shadow: none;
  background-color: transparent;
  align-items: center;
  position: relative;

 .icon {
    color: var(--primary-darker);
  }

  .full_w_input .icon {
    color: rgb(var(--colors-orange-700));
  }

  .input-wrapper {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: var(--shadow-color-darkest);
  }

  &.alt-job-sp {
    display: flex !important;
    justify-content: space-between;
    height: 64px;
    align-items: center;
    padding: 0 12px 0 16px;
    background-color: rgb(var(--colors-white));
    border-radius: 16px;
    box-shadow: var(--shadow-color-darkest);

    .input-wrapper {
      box-shadow: none;
      width: 100%;
    }

    &.large {
      height: 76px;

      & input,
      & .button-container {
        button {
          font-size: 16px;
        }
      }
    }

    &.large.only-location-input {
      padding: 0 16px 0 0;
    }

    & .keywords {
      flex-basis: 56%;
      border-right: 1px solid rgb(var(--colors-gray-200));
      margin-top: 0;
      border-radius: 0;
      border-bottom: none;
      background-color: transparent;
      box-shadow: none;

      .alt-btn {
        display: none;
      }

      & .icon {
        margin: 0 10px 0 0;
        font-size: 24px;
      }
    }

    & .location {
      flex-basis: 44%;
      margin-bottom: 0;
      border-radius: 0;
      border-bottom: none;
      background-color: transparent;
      box-shadow: none;
    }

    & .button-container {
      button {
        margin-top: 0;
      }
    }

    & .location.full_w_input {
      flex-basis: 98%;
      border: 0 !important;
    }
  }

  &.large {

    .keywords,
    .location {
     height: 76px;
    }


    & .button-container {
      font-size: 16px;
    }

    & input {
      font-weight: 400;
      font-size: 16px;
      color: rgb(var(--charcoal-lighter));

      &::placeholder {
        font-size: 16px !important;
        font-weight: 400 !important;
        color: rgb(var(--charcoal-lighter)) !important;
        opacity: 1;
      }
    }
  }

  & img {
    height: 20px;
    width: 18px;
  }

  & input {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    color: rgb(var(--colors-gray-900));
    font-family: "Montserrat", "sans-serif";
    font-weight: 400;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-right: 16px;
  }

  & .keywords {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(var(--colors-gray-200));
    background-color: rgb(var(--colors-white));

    & input {
      min-width: 250px;
    }

    .alt-btn {
      display: none;
    }

    .icon {
      margin: 0 8px 0 20px;
      font-size: 20px;
    }
  }

  & .location {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    background-color: rgb(var(--colors-white));

    & .icon {
      margin: 0 10px 0 20px;
      font-size: 18px;
    }
  }

  & .location.full_w_input {
    & .icon {
      margin: 0 10px 0 20px;
    }
  }

  & .button-container button {
    width: 100%;
    display: flex;
    margin-top: 16px;
    justify-content: center;
  }

  @screen md {
    height: 64px;
    align-items: center;
    padding: 0 12px 0 16px;
    background-color: rgb(var(--colors-white));
    border-radius: 16px;
    box-shadow: var(--shadow-color-darkest);

    .input-wrapper {
      box-shadow: none;
    }

    &.large {
      height: 76px;

      & input,
      & .button-container {
        button {
          font-size: 16px;
        }
      }
    }

    &.large.only-location-input {
      padding: 0 16px 0 0;
    }

    & .keywords {
      flex-basis: 56%;
      border-right: 1px solid rgb(var(--colors-gray-200));
      margin-top: 0;
      border-radius: 0;
      border-bottom: none;
      background-color: transparent;
      box-shadow: none;

      .alt-btn {
        display: none;
      }

      & .icon {
        margin: 0 10px 0 0;
        font-size: 24px;
      }
    }

    & .location {
      flex-basis: 44%;
      margin-bottom: 0;
      border-radius: 0;
      border-bottom: none;
      background-color: transparent;
      box-shadow: none;
    }

    & .button-container {
       button {
        margin-top: 0;
      }
    }

    & .location.full_w_input {
      flex-basis: 100%;
      border: 0 !important;
    }
  }
}

@media (max-width: 767px) {
  .alt {
    .icon {
      display: none
    }

    & .keywords {
      padding: 12px 12px 12px 16px;

      input {
        height: 100%;
        min-width: unset;
      }

      .alt-btn {
        height: 40px !important;
        width: 40px !important;
        border-radius: 8px;
        display: flex;
        justify-content: center;

        i.icon-search {
          font-size: 18px;
        }
      }
    }

    & .location {
      display: none;
      padding-left: 16px;
    }

    &.only-location-input {
      .icon {
        display: inline-block
      }

      & .location {
        padding-right: 16px;
        display: flex !important;
      }
    }

    & .button-container button {
      display: none;
    }
  }
}

.only-location-input form {
  width: 81%;
}

.advanced-search-isScrolled {
  width: 100% !important;
  position: fixed !important;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  transition: all .5s ease-in-out;

  @media (min-width: 1024px) {
    width: 100%!important;
    box-sizing: border-box;
  }

  & .vx-card {
    width: 100% !important;
    border-top-left-radius: 0!important;
    border-top-right-radius: 0!important;

    @media (min-width: 1280px) {
      display: flex;
      padding: 0 40px;

    }
  }
}

  .std-err-zip-code {
    font-size: 10px !important;
  }

</style>
